import * as React from "react";
import { useParams } from "react-router-dom";
import { useAuthState } from "../../../context/auth";
import { isFybrAdminUser } from "../adminRoles";
import { useInternalCloudAdminGate } from "../useInternalCloudAdminGate";
import { OrganizationSettingsPage } from "../OrganizationSettings/OrganizationSettingsPage";

export default function AdminInternalOrganizationEdit() {
  const gate = useInternalCloudAdminGate();
  const { currentUser } = useAuthState();
  const { id } = useParams<{ id: string }>();
  const organizationId = Number(id);

  if (gate !== "allowed") return null;

  return (
    <OrganizationSettingsPage
      organizationId={organizationId}
      canManageProvisionedResources={isFybrAdminUser(currentUser)}
    />
  );
}
